/** Helper methods for creating gradients. */
export var Gradients;
(function (Gradients) {
    Gradients.debug = [["red", 0.0], ["green", 0.5], ["blue", 1.0]];
    function shade(alpha = 0.2) {
        const color = "#000000".color().alpha(alpha);
        return [
            [color.string(), 0.0],
            ["#00000000", 1.0]
        ];
    }
    Gradients.shade = shade;
    /** Cylidrical shade. */
    function cylinder(base, delta = 5) {
        return [
            [base.l(base.l() + delta).string(), 0.0],
            [base.l(base.l() + 3 * delta).string(), 0.3],
            [base.string(), 0.6],
            [base.l(base.l() - delta).string(), 0.8],
            [base.l(base.l() + 2 * delta).string(), 1.0],
        ];
    }
    Gradients.cylinder = cylinder;
    /**
     * Suitable for a simple box, front view.
     * @param opts.shift Value from 0 to 1
     * @param opts.delta Value from 0 to 255.
     */
    function box(base, opts) {
        var _a, _b;
        const delta = (_a = opts === null || opts === void 0 ? void 0 : opts.delta) !== null && _a !== void 0 ? _a : 15;
        const shift = (_b = opts === null || opts === void 0 ? void 0 : opts.shift) !== null && _b !== void 0 ? _b : 0.15;
        return [
            [base.l(base.l() + delta).string(), 0.0],
            [base.string(), shift],
            [base.string(), 1 - shift],
            [base.l(base.l() - delta).string(), 1.0],
        ];
    }
    Gradients.box = box;
    function reflected(...stops) {
        return [
            ...stops.map(stop => [stop[0], stop[1]]),
            ...stops.reverse().map(stop => [stop[0], 1.0 - stop[1]])
        ];
    }
    Gradients.reflected = reflected;
    /** Simple gradient. Lighter at start, darker at end if range > 0 */
    function simple(base, range = 10) {
        return [
            [base.l(base.l() + range / 2).string(), 0.0],
            [base.l(base.l() - range / 2).string(), 1.0],
        ];
    }
    Gradients.simple = simple;
    function fade(base, opts) {
        var _a, _b;
        return [
            [base.string(), (_a = opts === null || opts === void 0 ? void 0 : opts.offset) !== null && _a !== void 0 ? _a : 0.0],
            [base.alpha((_b = opts === null || opts === void 0 ? void 0 : opts.finalAlpha) !== null && _b !== void 0 ? _b : 0.0).string(), 1.0],
        ];
    }
    Gradients.fade = fade;
    /** Scale the points, towards anchor */
    function scalePoints(stops, scale, anchor) {
        return stops.map(([color, stop]) => [color, (stop - anchor) * scale + anchor]);
    }
    Gradients.scalePoints = scalePoints;
})(Gradients || (Gradients = {}));
